
import React from 'react';

const ProcessSection: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: '需求沟通',
      description: '详细了解您的研究目标、数据类型和分析需求，制定个性化分析方案。',
      icon: 'ri-chat-3-line',
      color: 'bg-blue-500'
    },
    {
      number: '02',
      title: '数据接收',
      description: '安全接收您的原始数据，进行数据完整性检查和质量评估。',
      icon: 'ri-database-line',
      color: 'bg-green-500'
    },
    {
      number: '03',
      title: '质量控制',
      description: '对原始数据进行严格的质量控制，确保后续分析的准确性和可靠性。',
      icon: 'ri-shield-check-line',
      color: 'bg-orange-500'
    },
    {
      number: '04',
      title: '数据分析',
      description: '运用先进的生物信息学方法和工具，进行专业的数据分析处理。',
      icon: 'ri-line-chart-line',
      color: 'bg-purple-500'
    },
    {
      number: '05',
      title: '结果解读',
      description: '对分析结果进行深入解读，提供生物学意义的专业解释和建议。',
      icon: 'ri-book-open-line',
      color: 'bg-red-500'
    },
    {
      number: '06',
      title: '报告交付',
      description: '提供详细的分析报告、可视化图表和原始数据，确保结果可重现。',
      icon: 'ri-file-text-line',
      color: 'bg-indigo-500'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            专业的<strong>服务流程</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            标准化的<strong>六步服务流程</strong>，确保每个项目都能获得高质量的分析结果
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300 h-full">
                <div className="flex items-start space-x-4">
                  <div className={`w-12 h-12 flex items-center justify-center ${step.color} rounded-lg flex-shrink-0`}>
                    <i className={`${step.icon} text-white text-xl`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center space-x-3 mb-3">
                      <span className="text-2xl font-bold text-gray-300">{step.number}</span>
                      <h3 className="text-xl font-semibold text-gray-900">{step.title}</h3>
                    </div>
                    <p className="text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
              
              {/* 连接线 */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gray-300 transform -translate-y-1/2 z-10">
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-2 h-2 bg-gray-400 rounded-full"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
